import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { MultilevelMenuService, MultilevelNode, NgMaterialMultilevelMenuModule } from "ng-material-multilevel-menu";
import { CustomSnackBarService } from "../../services/custom-snack-bar.service";
import { AuthService } from "../../services/auth.service";
import { ConfigService } from "../../services/config.service";
import { GlobalVariablesService } from "../../services/global-variables.service";
import { ESSENTIALS, MATERIAL_FEEDBACK } from "../../utils/shared-components";
import { MenuItemButton } from "../../models/menu-item-button";

@Component({
  standalone: true,
  selector: "app-sidemenu",
  templateUrl: "./sidemenu.component.html",
  styleUrls: ["./sidemenu.component.css"],
  imports: [...ESSENTIALS, ...MATERIAL_FEEDBACK, NgMaterialMultilevelMenuModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [MultilevelMenuService]
})
export class SidemenuComponent implements OnInit {

  @Input() appId?: string;

  public configService = inject(ConfigService);
  public authService = inject(AuthService);
  public snackBar = inject(CustomSnackBarService);
  public router = inject(Router);
  public globalVariables = inject(GlobalVariablesService);

  logoi7Code;
  logoCliente;
  indLogoEmpresa;
  versao;

  constructor() {
    this.versao = this.configService.getInfo('version');
    this.logoi7Code = ConfigService.settings.ui.logos.i7Code;
    this.logoCliente = ConfigService.settings.ui.logos.customer;
  }

  ambiente: string;


  menu: MultilevelNode[] = [];

  ngOnInit() {
    this.ambiente = ConfigService.settings.app.environmentName;
    this.indLogoEmpresa = Boolean(ConfigService.settings.ui.logos.customer);
    this.buscarEstruturaMenu();
  }

  public get auth() {
    return this.authService;
  }

  buscarEstruturaMenu() {
    this.authService.buscaEstruturaMenu(this.getAppId()).subscribe({
      next: (response) => {
        this.montaMenu(response.body?.data ?? []);
      }
    });

  }

  private getAppId(): string {
    return String(this.appId || ConfigService.settings.app.id || 'ERP').trim().toUpperCase();
  }

  private montaMenu(lista: any[]) {
    const menu: MenuItemButton[] = [];
    this.montaMenuRecursivo(menu, lista);

    this.authService.setEstruturaMenu(menu);
    this.menu = menu as unknown as MultilevelNode[];
  }

  private montaMenuRecursivo(pai: MenuItemButton[], lista: any[]) {
    lista.forEach(element => {
      const items: MenuItemButton[] = [];
      const hasSubmenus = element.submenus && element.submenus.length > 0;

      if (hasSubmenus) {
        this.montaMenuRecursivo(items, element.submenus);
      }

      pai.push({
        label: element.descricao,
        link: hasSubmenus ? null : element.rotaWeb,
        icon: "",
        id: element.id,
        items: items as [],
        hidden: false,
        identificador: element.identificador
      });
    });
  }

  config = {
    paddingAtStart: true,
    classname: "my-custom-class",
    fontColor: "#fff",
    selectedListFontColor: "#ffffff",
    interfaceWithRoute: true,
    collapseOnSelect: true,
    highlightOnSelect: true,
  };

  selectedItem(event) {
    if (event.link == "/logout") {
      this.authService.logout();
      return;
    }
    this.globalVariables.telaAtiva = event.label;
    this.router.navigate(["/" + event.link]);
  }
}
